import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  title: "",
  link:""

};

export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    setPageTitle: (state, action) => {
     state.title = action.payload;
    },
    setPageLink: (state, action) => {
      state.link = action.payload;
    },
   
   
  },
});

export const {
 setPageTitle,
 setPageLink,
} = pageSlice.actions;
export default pageSlice.reducer;
